import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../assets/images/logo.svg";
import { useSectionNavigation } from "./contexts/SectionContext";

export default function Header() {
  const { scrollToSection, activeSection } = useSectionNavigation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);

  const sections = [
    { id: "home", title: "Главная" },
    { id: "ecosystem", title: "Экосистема" },
    { id: "press", title: "Пресс-центр" },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 769);
      if (window.innerWidth >= 769) setIsMenuOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = (id, e) => {
    e.preventDefault();
    if (isMobile) setIsMenuOpen(false);

    if (location.pathname === "/") {
      scrollToSection(id);
    } else {
      navigate(`/#${id}`);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <nav className="navbar sticky">
        <div className="container">
          <Link
            to="/"
            onClick={(e) => {
              e.preventDefault();
              if (location.pathname === "/") {
                scrollToSection("home");
              } else {
                navigate("/");
              }
              if (isMobile) setIsMenuOpen(false);
            }}
          >
            <img src={logo} alt="logo" className="logo" />
          </Link>

          {/* Кнопка меню для мобильных */}
          {isMobile && (
            <button
              className={`btn-toggler btnMenu ${isMenuOpen ? "active" : ""}`}
              onClick={toggleMenu}
              aria-label="Toggle menu"
              aria-expanded={isMenuOpen}
            >
              <span className="menu-icon"></span>
            </button>
          )}

          {/* Основное меню */}
          {!isMobile ? (
            <div className="nav-menu">
              <ul className="nav">
                {sections.map(({ id, title }) => (
                  <li key={id}>
                    <a
                      href={`#${id}`}
                      className={activeSection === id ? "active" : ""}
                      onClick={(e) => handleClick(id, e)}
                    >
                      {title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <AnimatePresence>
              {isMenuOpen && (
                <>
                  <motion.div
                    className="menu-overlay"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={() => setIsMenuOpen(false)}
                  />

                  <motion.div
                    className="nav-menu mobile"
                    initial={{ x: "100%" }}
                    animate={{ x: 0 }}
                    exit={{ x: "100%" }}
                    transition={{
                      type: "tween",
                      ease: "easeInOut",
                      duration: 0.3,
                    }}
                  >
                    <ul className="nav">
                      {sections.map(({ id, title }, index) => (
                        <motion.li
                          key={id}
                          initial={{ opacity: 0, x: 20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: 0.1 * index }}
                        >
                          <a
                            href={`#${id}`}
                            className={activeSection === id ? "active" : ""}
                            onClick={(e) => handleClick(id, e)}
                          >
                            {title}
                          </a>
                        </motion.li>
                      ))}
                    </ul>
                  </motion.div>
                </>
              )}
            </AnimatePresence>
          )}
        </div>
      </nav>
    </header>
  );
}
